import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import * as mainActions from '../actions/mainActions';
import { connect } from 'react-redux';
import Report from 'react-powerbi';
import { getAccessToken } from '../controllers/reportsBi';
//const REPORT_ID = '2f390b5e-775e-49f3-9b66-0962a59c5419'; //JOSE
//const GROUP_ID = '6a49b839-1ffc-4e45-94de-dda47dbf7341'; //JOSE
const REPORT_ID = '4700b260-7037-40d1-b6d7-22587d0afadf';
const GROUP_ID = 'me';


class ReportsBi extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            embedConfig: {
                id: "4700b260-7037-40d1-b6d7-22587d0afadf", //2f390b5e-775e-49f3-9b66-0962a59c5419 // JOSE
                embedUrl: `https://msit.powerbi.com/reportEmbed?reportId=${REPORT_ID}&groupId=${GROUP_ID}`,
            },
            filter: null,
            accessToken: ''
        }
    }

    onEmbedded(embed) {
        console.log(`Report embedded: `, embed, this);
    }

    async componentDidMount() {
        const { sessionData } = this.props.main;
        let accessToken = await getAccessToken(sessionData);
        if (sessionData.municipality) {
            this.setState({ filter: { target: { table: 'municipalities', column: 'id' }, operator: "In", values: [sessionData.municipality]  } })
        }
        this.setState({ accessToken, loading: false })
    }

    render() {
        const { embedConfig, accessToken, loading, filter } = this.state;
        return (
            <Fragment>
                {/* <div> Informes avanzados de enquisas</div> */}
                {!loading &&
                    <div style={{ height: 'calc(100vh - 70px)', width: '100%' }}>
                        <Report
                            filters={filter ? [filter] : null}
                            embedType="report"
                            id={embedConfig.id}
                            embedUrl={embedConfig.embedUrl}
                            accessToken={accessToken}
                            filterPaneEnabled={false}
                            navContentPaneEnabled={true}
                            onEmbedded={this.onEmbedded}
                            height={'100%'}
                        />
                    </div>
                }
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsBi);



// WEBPACK FOOTER //
// ./src/components/ReportsBi.js